import React from 'react'
import {
    Link
} from "react-router-dom";
import { useAuth } from '../auth/AuthContext';
import { LANGUAGES, useT } from '../i18n';


import mainLogo from '../assets/images/kanosei/main__logo.png';
import respo_logo from '../assets/images/kanosei/main__logo.png';


// Converted from a class component so it can read auth state via useContext.
// It had no lifecycle methods or props, so the conversion is behaviour-neutral
// apart from the new conditional link.
function Header() {
    const { isSignedIn, signIn } = useAuth();
    const { t, lang, setLang } = useT();

    return (
        <>
            <header>
                <nav>
                    <Link to="/" className="logo" href="/">
                        <img src={`${mainLogo}`} alt="" className="desktop_logo" />
                        <img src={`${respo_logo}`} alt="" className="respo_logo" />
                    </Link>
                    <ul>
                        {/* Two public pages, and only one of them needs a link:
                            the landing is the logo. `investments` and `contact`
                            are gone — we publish no holdings and take no
                            inbound, so both were pages that led nowhere. Their
                            routes still redirect; see AppRouter. */}
                        <li><Link to="/collection" >{t('nav.artCollection')}</Link></li>
                        {/* Shown only when signed in. Hiding it is presentation
                            only — /holdings is guarded by RequireAuth, and the
                            data behind it by the API. */}
                        {isSignedIn && <li><Link to="/holdings">{t('nav.portfolio')}</Link></li>}
                    </ul>
                    {/* Outside the <ul> deliberately. Below 1024px that list
                        becomes a fixed panel that only appears once the
                        hamburger is tapped, so a toggle inside it would be
                        unreachable until the menu was open. As a sibling of the
                        hamburger it stays in the bar at every width. */}
                    <div className="nav__lang" role="group" aria-label={t('lang.label')}>
                        {LANGUAGES.map(([code, label]) => (
                            <button
                                key={code}
                                type="button"
                                className={`nav__lang_btn${lang === code ? ' is-active' : ''}`}
                                aria-pressed={lang === code}
                                onClick={() => setLang(code)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                    {/* Sign-in lived only inside the slide-out panel, which is
                        two taps and a guess behind a hamburger. Kept out of the
                        <ul> for the same reason the language toggle is: below
                        1024px that list becomes a fixed panel that only appears
                        once the hamburger is tapped, so a control inside it is
                        unreachable until the menu is open — which is no use to
                        someone looking for the way in.

                        Shown at every width, not only on mobile. It was equally
                        buried on desktop, and hiding it above 1024px would be
                        more code for a worse result. The panel keeps its own
                        copy: someone already in the menu should not have to
                        leave it to sign in. */}
                    {!isSignedIn && (
                        <button
                            type="button"
                            className="nav__signin"
                            onClick={() => signIn('/holdings')}
                        >
                            {t('common.signIn')}
                        </button>
                    )}
                    <div className="sidebar__toggle">
                        <span className="toggle__icon"></span>
                    </div>
                </nav>
            </header>
        </>
    )
}

export default Header;
